import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';
import fullOrgUrl from './fullOrgUrl';

const PROVISION_FRAGMENT = gql(`
  fragment provisionRegisterUrl_provision on Provision {
    id
    secret
  }
`);

export default function provisionRegisterUrl(
  provision: DocumentType<typeof PROVISION_FRAGMENT>,
) {
  return (
    provision.id &&
    provision.secret &&
    fullOrgUrl(`/register/${provision.id}/${provision.secret}`)
  );
}
